// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header {\n  padding-top: 13px\n}\n.body {\n  padding-top: 6px\n}\n.el-centered {\n  height: 50vh !important\n}\n", ""]);
// Exports
module.exports = exports;
